var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { AppearState, QuestionAnswerState } from '../../learnware/LearnwareEnums';
export class QuestionAppear {
    parent;
    appearState;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get currentAppearState() {
        if (this.appearState)
            return this.appearState;
        return AppearState.Visible;
    }
    get shouldBeVisible() {
        if (this.question.answeringState.isInHistoryState) {
            return true;
        } // history question showing
        if (this.question.answeringState.shouldContinueImmediately ||
            (this.question.answeringState.currentAnswerState === QuestionAnswerState.Feedback &&
                this.question.answeringFeedback.isFeedbackTimeNearlyOver)) {
            // speedup !
            // setTimeout(this.hideQuestion, 1);
            return false;
        }
        return true;
    }
}
__decorate([
    observable
], QuestionAppear.prototype, "appearState", void 0);
__decorate([
    computed // checked, avoid rerenderings 19.01.2019
], QuestionAppear.prototype, "shouldBeVisible", null);
